/** Screen routes rendered inside the shell. Each screen owns one file (+ co-located CSS). */
import type { RouteObject } from "react-router";
import { Changes } from "./Changes";
import { Home } from "./Home";

export const screenRoutes: RouteObject[] = [
  { index: true, element: <Home /> },
  { path: "changes", element: <Changes /> },
  { path: "apps", lazy: () => import("./Apps").then((m) => ({ Component: m.Apps })) },
  { path: "v1/*", lazy: () => import("./V1").then((m) => ({ Component: m.V1 })) },
  { path: "ads", lazy: () => import("./Ads").then((m) => ({ Component: m.Ads })) },
  { path: "campaigns", lazy: () => import("./Campaigns").then((m) => ({ Component: m.Campaigns })) },
  {
    path: "campaigns/new",
    lazy: () => import("./NewCampaign").then((m) => ({ Component: m.NewCampaign })),
  },
  { path: "products", lazy: () => import("./Products").then((m) => ({ Component: m.Products })) },
  { path: "products/:id", lazy: () => import("./Product").then((m) => ({ Component: m.Product })) },
  { path: "profit", lazy: () => import("./Profit").then((m) => ({ Component: m.Profit })) },
  { path: "analytics", lazy: () => import("./Analytics").then((m) => ({ Component: m.Analytics })) },
  { path: "reports", lazy: () => import("./Reports").then((m) => ({ Component: m.Reports })) },
  { path: "measurement", lazy: () => import("./Measurement").then((m) => ({ Component: m.Measurement })) },
  {
    path: "search-terms",
    lazy: () => import("./keywords/SearchTerms").then((m) => ({ Component: m.SearchTerms })),
  },
  {
    path: "keywords",
    lazy: () => import("./keywords/KeywordLab").then((m) => ({ Component: m.KeywordLab })),
  },
  {
    path: "keywords/planner",
    lazy: () => import("./keywords/Planner").then((m) => ({ Component: m.Planner })),
  },
  {
    path: "keywords/negative-lists",
    lazy: () => import("./keywords/NegativeLists").then((m) => ({ Component: m.NegativeLists })),
  },
  { path: "vk/chat", lazy: () => import("./vk/VkChat").then((m) => ({ Component: m.VkChat })) },
  { path: "vk/calendar", lazy: () => import("./vk/VkCalendar").then((m) => ({ Component: m.VkCalendar })) },
  { path: "vk/meta", lazy: () => import("./vk/VkMeta").then((m) => ({ Component: m.VkMeta })) },
  { path: "vk/email", lazy: () => import("./vk/VkEmail").then((m) => ({ Component: m.VkEmail })) },
  { path: "vk/creative", lazy: () => import("./vk/VkCreative").then((m) => ({ Component: m.VkCreative })) },
  {
    path: "vk/giveaways",
    lazy: () => import("./vk/VkGiveaways").then((m) => ({ Component: m.VkGiveaways })),
  },
  {
    path: "vk/analytics",
    lazy: () => import("./vk/VkAnalytics").then((m) => ({ Component: m.VkAnalytics })),
  },
  { path: "vk/work", lazy: () => import("./vk/VkWork").then((m) => ({ Component: m.VkWork })) },
  { path: "inbox", lazy: () => import("./Inbox").then((m) => ({ Component: m.Inbox })) },
  { path: "automations", lazy: () => import("./Automations").then((m) => ({ Component: m.Automations })) },
  { path: "growth", lazy: () => import("./platform/Growth").then((m) => ({ Component: m.Growth })) },
  { path: "catalog", lazy: () => import("./platform/Catalog").then((m) => ({ Component: m.Catalog })) },
  { path: "seo", lazy: () => import("./platform/ProductSeo").then((m) => ({ Component: m.SeoIndex })) },
  {
    path: "seo/:productId",
    lazy: () => import("./platform/ProductSeo").then((m) => ({ Component: m.ProductSeo })),
  },
  {
    path: "collections",
    lazy: () => import("./platform/Collections").then((m) => ({ Component: m.Collections })),
  },
  { path: "team", lazy: () => import("./platform/Team").then((m) => ({ Component: m.Team })) },
  { path: "brand", lazy: () => import("./platform/Brand").then((m) => ({ Component: m.Brand })) },
  { path: "settings", lazy: () => import("./platform/Settings").then((m) => ({ Component: m.Settings })) },
  { path: "system", lazy: () => import("./platform/System").then((m) => ({ Component: m.System })) },
  { path: "ai-usage", lazy: () => import("./platform/AiUsage").then((m) => ({ Component: m.AiUsage })) },
  { path: "integrations", lazy: () => import("./platform/ApiKeys").then((m) => ({ Component: m.ApiKeys })) },
  {
    path: "onboarding",
    lazy: () => import("./platform/Onboarding").then((m) => ({ Component: m.Onboarding })),
  },
];
